export let PlanTypeEnum=/*#__PURE__*/function(PlanTypeEnum){PlanTypeEnum["SUPPORT"]="support";PlanTypeEnum["TENANT"]="tenant";return PlanTypeEnum;}({});